import { isEmpty, isFinite, isNumber, isString, toNumber as lodashToNumber, trim, values } from "lodash";

export function enumKeys<T extends Record<string | number | symbol, unknown>>(entity: T): (keyof T)[] {
  return values(entity).filter(isString);
}

export function toNumber(value: string): number | null {
  if (isNumber(value)) {
    return value;
  }
  if (isEmpty(trim(value))) {
    return null;
  }
  const num = lodashToNumber(value.replace(",", "."));
  if (isFinite(num)) {
    return num;
  } else {
    return null;
  }
}

export function updateArr<T>(values: T[], idx: number, value: T) {
  return [...values.slice(0, idx), value, ...values.slice(idx + 1)];
}

export function removeArr<T>(values: T[], idx: number) {
  return [...values.slice(0, idx), ...values.slice(idx + 1)];
}

export function swapArr<T>(values: T[], idxA: number, idxB: number): T[] {
  const copy = [...values];
  [copy[idxA], copy[idxB]] = [copy[idxB], copy[idxA]];
  return copy;
}

export function formatNumber(n: number | undefined) {
  if (n === undefined) {
    return n;
  }
  return isFinite(n) ? n.toFixed(2).replace(".", ",") : n;
}

export function assertUnreachable(value: never, messagePrefix = "Unexpected value"): never {
  throw new Error(`${messagePrefix}: ${value}`);
}
